import styled from 'styled-components';

export const Container = styled.div`
  .card {
    border-radius: 4px 4px 0px 0px;
    background-color: #f7ecd0;
  }

  .card-progress {
    background-color: #f0f1f2;
  }

  .progress {
    height: 25px;
  }

  .title {
    color: #495057;
  }
`;
